import { Component, OnInit, signal } from '@angular/core';
import { PropertyService } from './../../../shared/services/property.service';
import { brandByExternalId_brandByExternalId_properties } from 'src/app/shared/graphql/types/brandByExternalId';
import { propertySearchFn } from 'src/app/shared/functions/propertySearchFn';
import { Router, NavigationEnd } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthService } from './../../loyalty/auth.service';
import { filter, map,  } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

enum DestinationCurrentTab {
  State = 'state',
  Brand = 'brand'
}

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  isLoggedIn = signal<boolean>(false);
  assets_base: string = environment.assets_base;
  isHome: boolean = false;
  brands: any[] = [
    {
      name: 'Fairbridge Inn & Suites',
      image: 'assets/svg/FairBridgeInn_Suites_Logo.svg'
    },
    {
      name: 'FairBridge Inn Express',
      image: 'assets/svg/FairBridgeInn_Express_Logo.svg'
    },
    {
      name: 'Loyalty Inn',
      image: 'assets/images/brand/LoyaltyInn_logo.webp'
    }
  ];

  properties: brandByExternalId_brandByExternalId_properties[] = [];
  propertySearchFn = propertySearchFn;
  propertyLoading: boolean;
  selectedProperty: brandByExternalId_brandByExternalId_properties;
  propertiesByType: any[] = [];
  DestinationEnum = DestinationCurrentTab;
  destinationCurrentTab: string = DestinationCurrentTab.State;

  currentStateTitleProperties: any;
  propertyHovered: brandByExternalId_brandByExternalId_properties;

  constructor(
    private propertyService: PropertyService,
    private router: Router,
    private authService: AuthService) {

      this.router.events
      .pipe(
      takeUntilDestroyed(),
      filter(event => event instanceof NavigationEnd), 
      map((event: NavigationEnd) => {
        const route = event.url;
        return {route}
      })).subscribe(res=> {
        this.isHome = res.route === '/' || res.route === '/#brands';
      });

      this.isLoggedIn.set(this.authService.isLoggedIn);
  }

  ngOnInit(): void {
    this.getLoginStatus();
    this.getBrandDetails();
  }

  getBrandDetails() {
    this.propertyLoading = true;
    this.propertyService.brand$.subscribe(res => {
      this.properties = [...res.properties];
      this.properties = this.properties.sort((a, b) => 
        (a?.state ?? '').toUpperCase().localeCompare((b?.state ?? '').toUpperCase())
      );
      this.propertyLoading = false;
      this.groupProperties();
    });
  }

  onPropertyChange(event) {
    this.router.navigate(['/hotel', event.slug]);
    this.selectedProperty = null;
  }

  onDestinationType(type: DestinationCurrentTab) {
    this.destinationCurrentTab = type;
    this.currentStateTitleProperties = null;
    this.groupProperties();
  }

  onStateTitle(stateProperties) {
    this.currentStateTitleProperties = stateProperties;
  }

  onBack() {
    this.currentStateTitleProperties = null;
  }

  onPropertyTitleHover(property) {
    this.propertyHovered = property;
  }

  getHoveredPropertyImg() {
    if (this.propertyHovered.propertyImages) {
      return this.propertyHovered.propertyImages.find(entry => entry.accessCode === '001').imagePath;
    }
    return null;
  }

  logout() {
    this.authService.logout();
  }

  getLoginStatus() {
    this.authService.isLoggedIn$.subscribe((_res) => {
      this.isLoggedIn.set(this.authService.isLoggedIn);
    });
  }

  groupProperties() {
    this.propertiesByType = [];
    if (this.destinationCurrentTab === DestinationCurrentTab.State) {
      const groupBy = (array, key) => {
        return array.reduce((result, currentValue) => {
          (result[currentValue[key]] = result[currentValue[key]] || []).push(
            currentValue
          );
          return result;
        }, {});
      };
      const propertiesObject = groupBy(this.properties, 'state');

      for (const property in propertiesObject) {
        if (property && property !== 'null') {
          this.propertiesByType.push({
            title: property,
            properties: propertiesObject[property]
          });
        }
      }

      this.propertiesByType = this.propertiesByType.sort(function (a, b) {
        var nameA = a?.state?.toUpperCase();
        var nameB = b?.state?.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
    } else if (this.destinationCurrentTab === DestinationCurrentTab.Brand) {
      for (let i = 0; i < this.brands.length; i++) {
        let list = this.properties.filter(entry => {
          return entry.hotelCategory.includes(this.brands[i].name);
        });
        this.propertiesByType.push({
          title: this.brands[i].name,
          image: this.brands[i].image,
          properties: list
        });
      }
    }
  }
}

